import { createContext, Ref, useContext } from 'react'

import { isNil } from 'lodash-es'

import { SelectProps } from '@forto-dev/phoenix-ui-core'

export type LocationSelectProps = Omit<SelectProps, 'items'>
export type LocationSelectorContextState = {
  accountID: string
  manualMode: boolean
  value?: string
  label?: string
  required?: boolean
  inputRef?: Ref<unknown>
  errorMessage?: string
  disabled?: boolean
  manualActionProps?: {
    buttonLabel?: string
    dialogTitle?: string
    dialogDescription?: string
  }
  selectProps?: LocationSelectProps
}

export const LocationSelectorContext = createContext<LocationSelectorContextState | null>(null)

export const useLocationSelectorContext = (): LocationSelectorContextState => {
  const ctx = useContext(LocationSelectorContext)

  if (isNil(ctx)) {
    throw new Error('useLocationSelectorContext must be used within a LocationSelectorContext.Provider')
  }

  return ctx
}
